(ns practitest.frontend.summary.subs
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.summary.events :as events]))

(re-frame/reg-sub
 ::state
 (fn [db _]
   (get db events/db-key)))

(re-frame/reg-sub
 ::field
 :<- [::state]
 (fn [state [_ k]]
   (get state k)))

(re-frame/reg-sub
 ::current-tab
 :<- [::state]
 (fn [{:keys [tabs current-tab-id]} _]
   (some #(when (= (:id %) current-tab-id) %) tabs)))

(re-frame/reg-sub
 ::item-status
 :<- [::state]
 (fn [state [_ id]]
   (get-in state [:item-status id])))
